import React from 'react';
import {
  confirmable,
  createConfirmation,
} from 'react-confirm';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const FileAttachmentDownloadDialog = ({
  show,
  dismiss,
  cancel,
  options,
}) => {
  const {
    t,
  } = useTranslation(undefined, { useSuspense: false });

  return (
      <Dialog
          open={show}
          onClose={dismiss}
          className="file-attachment-download-dialog"
      >
        <DialogTitle>
          {options.scan_status === 'pending' && (
              t('Scan in progress')
          )}
          {options.scan_status === 'fail' && (
              t('Scan failed')
          )}
        </DialogTitle>
        <DialogContent>
          {options.scan_status_message}
        </DialogContent>
        <DialogActions>
          <Button
              onClick={() => { cancel() }}
              className="file-attachment-download-close-button"
          >
            {t('Close')}
          </Button>
        </DialogActions>
      </Dialog>
  );
}

const confirm = createConfirmation(confirmable(FileAttachmentDownloadDialog));

export default function(content, options = {}) {
  return confirm({ content, options });
}

